import './Skeleton.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  dark?: boolean;
  className?: string;
}

export function Skeleton({ width, height, borderRadius, dark, className = '' }: SkeletonProps) {
  return (
    <div
      className={`skeleton ${dark ? 'skeleton--dark' : ''} ${className}`}
      style={{ width, height, borderRadius }}
    />
  );
}

export function SkeletonCard({ dark }: { dark?: boolean }) {
  const cls = dark ? 'skeleton skeleton--dark' : 'skeleton';
  return (
    <div className="skeleton-card">
      <div className={`${cls} skeleton-avatar`} />
      <div className="skeleton-card-lines">
        <div className={`${cls} skeleton-title`} />
        <div className={`${cls} skeleton-bar`} style={{ width: '80%' }} />
      </div>
    </div>
  );
}

export function SkeletonList({ count = 5, dark }: { count?: number; dark?: boolean }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} dark={dark} />
      ))}
    </div>
  );
}

/** Dashboard: logo + barra de busca + botao IA */
export function SkeletonDashboard() {
  return (
    <div className="skeleton-dashboard">
      <div className="skeleton skeleton-dashboard-logo" />
      <div className="skeleton skeleton-dashboard-searchbar" />
      <div className="skeleton skeleton-dashboard-divider" />
      <div className="skeleton skeleton-dashboard-btn" />
    </div>
  );
}

/** Library row: titulo + autor/ano + badge tipo + estrela */
export function SkeletonLibraryRow() {
  return (
    <div className="skeleton-library-row">
      <div className="skeleton-library-row-lines">
        <div className="skeleton skeleton-library-title" />
        <div className="skeleton-library-meta">
          <div className="skeleton skeleton-library-author" />
          <div className="skeleton skeleton-library-badge" />
          <div className="skeleton skeleton-library-star" />
        </div>
      </div>
    </div>
  );
}

/** PDF page: retangulo A4 com linhas de texto simuladas */
export function SkeletonPdfPage() {
  return (
    <div className="skeleton-pdf-container">
      <div className="skeleton-pdf-page">
        {[90, 85, 88, 70, 92, 80, 75, 88, 60, 85].map((w, i) => (
          <div
            key={i}
            className="skeleton skeleton--dark skeleton-pdf-line"
            style={{ width: `${w}%` }}
          />
        ))}
      </div>
    </div>
  );
}
